import InputCus from "../../Component/InputCus/Text/InputCus";
import { useEffect, useState } from "react";
import {
  CompanyDeleteCompany,
  CompanyFilterCompany,
  CompanyChangeOrderCompany,
} from "../../Api/Services";
import imgDelete from "../../assets/Icon/icons8-remove-100.png";
import imgIdentity from "../../assets/Icon/icons8-identity-64.png";
import imgDoc from "../../assets/Icon/icons8-edit-48.png";
import StoreImg from "../../assets/Icon/logistics.png";
import { confirmAlert } from "react-confirm-alert";
import imgPlus from "../../assets/Icon/pluse.png";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

function Company() {
  const [Search, setSearch] = useState({});
  const [Data, setData] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const navigate = useNavigate();

  const start = async () => {
    try {
      const CompanyFilterCompanyData = await CompanyFilterCompany({});
      if (
        CompanyFilterCompanyData.status &&
        CompanyFilterCompanyData.status === 200
      ) {
        setData(CompanyFilterCompanyData.data.data.data);
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  const Clear = async () => {
    setSearch({});
    setLoading(true);
    try {
      const CompanyFilterCompanyData = await CompanyFilterCompany({});
      if (
        CompanyFilterCompanyData.status &&
        CompanyFilterCompanyData.status === 200
      ) {
        setData(CompanyFilterCompanyData.data.data.data);
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  const Searched = async () => {
    try {
      setLoading(true);
      const CompanyFilterCompanyData = await CompanyFilterCompany({
        ...Search,
      });
      if (
        CompanyFilterCompanyData.status &&
        CompanyFilterCompanyData.status === 200
      ) {
        setData(CompanyFilterCompanyData.data.data.data);
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  const confirmDelete = (e) => {
    confirmAlert({
      title: "حذف  شرکت",
      message: "آیا مطمئن هستید ؟",
      buttons: [
        {
          label: "بله",
          onClick: () => DeleteItem(e),
        },
        {
          label: "خیر",
        },
      ],
    });
  };

  const DeleteItem = async (e) => {
    try {
      setLoading(true);
      const CompanyDeleteCompanyData = await CompanyDeleteCompany(e);
      if (
        CompanyDeleteCompanyData.status &&
        CompanyDeleteCompanyData.status === 200
      ) {
        toast.success("عملیات با موفقیت انجام شد");
        await start();
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  const Add = () => {
    navigate("/Panel/Companys/Add");
  };

  const ShowStore = (id) => {
    navigate("/Panel/Companys/Store/" + id);
  };

  const Edite = (id) => {
    navigate("/Panel/Companys/Edite/" + id);
  };

  const Identity = (id) => {
    navigate("/Panel/Companys/Identity/" + id);
  };

  const ChandeOrder = async (e) => {
    const newSearch = [...Data];
    newSearch.find((w) => w.id == e.target.id).order = e.target.value;
    setData(newSearch);
  };

  const FixChandeOrder = async (e) => {
    if (e.key == "Enter") {
      try {
        setLoading(true);
        const CompanyChangeOrderCompanyData = await CompanyChangeOrderCompany({
          id: e.target.id,
          order: e.target.value,
        });
        if (
          CompanyChangeOrderCompanyData.status &&
          CompanyChangeOrderCompanyData.status === 200
        ) {
          toast.success("عملیات با موفقیت انجام شد");
          await start();
        }
      } catch (error) {
        console.error("Error during login:", error);
      } finally {
      }
    }
  };

  const handleChangeSearch = (e) => {
    const newSearch = { ...Search };
    newSearch[e.target.id] = e.target.value;
    setSearch(newSearch);
  };
  const shortText = (text, maxLength = 20) => {
    if (!text) return "";
    return text.length > maxLength
      ? text.substring(0, maxLength) + "..."
      : text;
  };
  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-start align-items-start flex-column element p-5">
          <div className="d-flex justify-content-start align-items-center w-100 mb-5 pointer">
            <img
              onClick={() => {
                Add();
              }}
              src={imgPlus}
              alt=""
            />
          </div>
          <div className="d-flex justify-content-start align-items-center flex-wrap">
            <InputCus
              type="text"
              name="name"
              id="name"
              text="نام"
              className="m-2"
              value={Search.name || ""}
              onChange={handleChangeSearch}
            />
          </div>
          <div className="d-flex justify-content-between align-items-center w-100 mb-3">
            <div onClick={Searched} className="btnSearch">
              جست و جو
            </div>
            <div onClick={Clear} className="btnCancel">
              بروزرسانی
            </div>
          </div>
          <div className="d-flex justify-content-center align-items-center w-100 p-2 tableC">
            <table className="table">
              <thead className="sticky-header">
                <tr className="trTable">
                  <th>الویت نمایش</th>
                  <th>نام</th>
                  <th>برنامه انبارداری</th>
                  <th>1دیتا اتصال</th>
                  <th>2دیتا اتصال</th>
                  <th>3دیتا اتصال</th>
                  <th>4دیتا اتصال</th>
                  <th>5دیتا اتصال</th>
                  <th>6دیتا اتصال</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {Data.map((item, key) => (
                  <tr key={key}>
                    <td>
                      <input
                        id={item.id}
                        className="w-25"
                        value={item.order}
                        onKeyUp={(e) => FixChandeOrder(e)}
                        onChange={(e) => ChandeOrder(e)}
                      />
                    </td>
                    <td>{shortText(item.name)}</td>
                    <td>{shortText(item.warehouseName)}</td>
                    <td>{shortText(item.dataConection1)}</td>
                    <td>{shortText(item.dataConection2)}</td>
                    <td>{shortText(item.dataConection3)}</td>
                    <td>{shortText(item.dataConection4)}</td>
                    <td>{shortText(item.dataConection5)}</td>
                    <td>{shortText(item.dataConection6)}</td>
                    <td className="td-actions">
                      <span
                        className="d-inline-block pointer ms-2"
                        tabIndex="0"
                        data-bs-toggle="tooltip"
                        title="حذف"
                      >
                        <img
                          height="30"
                          className="me-2"
                          src={imgDelete}
                          alt="حذف"
                          onClick={() => {
                            confirmDelete(item.id);
                          }}
                        />
                      </span>
                      <span
                        className="d-inline-block pointer"
                        tabIndex="0"
                        data-bs-toggle="tooltip"
                        title="ویرایش"
                      >
                        <img
                          height="30"
                          src={imgDoc}
                          alt="ویرایش"
                          onClick={() => {
                            Edite(item.id);
                          }}
                        />
                      </span>
                      <span
                        className="d-inline-block pointer m-2"
                        tabIndex="0"
                        data-bs-toggle="tooltip"
                        title="دسترسی"
                      >
                        <img
                          height="40"
                          src={imgIdentity}
                          alt="دسترسی"
                          onClick={() => {
                            Identity(item.id);
                          }}
                        />
                      </span>
                      <span
                        className="d-inline-block pointer me-2"
                        tabIndex="0"
                        data-bs-toggle="tooltip"
                        title="انبار"
                      >
                        <img
                          height="40"
                          src={StoreImg}
                          alt="انبار"
                          onClick={() => {
                            ShowStore(item.id);
                          }}
                        />
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Company;
